import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment/moment";
import { createpayslip, liststaff, payslipattendance, viewpayslip, viewstructure } from "../../../services/admin";
import { numberToWordsINR } from "./numtowords";

export default function Addpayslip() {
    const navigate = useNavigate();
    const [urllink, setUrllink] = useState("");
    const { id } = useParams();

    const [slist, setSList] = useState([]);
    const [staff, setStaff] = useState("");
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [paydate, setPayDate] = useState("");

    const [paydays, setPaydays] = useState("");
    const [attarrear, setAttarrear] = useState("");
    const [incarrear, setIncarrear] = useState("");
    const [totaldays, setTotaldays] = useState("");
    const [lopfetching, setLopfetching] = useState(false);
    const [lopValidate, setLopValidate] = useState(false);
    const [lopInfo, setLopInfo] = useState("");
    const [saveErr, setSaveErr] = useState("");

    // Earnings : Basic / HRA / Advance towards statutory Bonus (rate, monthly, arrear)
    const [basicRate, setBasicRate] = useState("");
    const [basicMonthly, setBasicMonthly] = useState("");
    const [basicArrear, setBasicArrear] = useState("");
    const [hraRate, setHraRate] = useState("");
    const [hraMonthly, setHraMonthly] = useState("");
    const [hraArrear, setHraArrear] = useState("");
    const [bonusRate, setBonusRate] = useState("");
    const [bonusMonthly, setBonusMonthly] = useState("");
    const [bonusArrear, setBonusArrear] = useState("");

    // Deductions
    const [pf, setPf] = useState("");
    const [esi, setEsi] = useState("");
    const [pt, setPt] = useState("");

    const [remarks, setRemarks] = useState("");
    const [generated, setGenerated] = useState(false);

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
    ];

    const n = (v) => parseFloat(v) || 0;

    // Editing any input invalidates the generated preview.
    function numChange(setter) {
        return (e) => {
            const regex = /^[0-9\b.]+$/;
            if (e.target.value === "" || regex.test(e.target.value)) {
                setter(e.target.value);
                setGenerated(false);
            }
        };
    }
    function anyChange(setter) {
        return (e) => {
            setter(e.target.value);
            setGenerated(false);
        };
    }

    // Selecting a staff auto-fills their saved salary structure (Basic/HRA/Bonus + PF/ESI/PT).
    function handleStaffChange(e) {
        const val = e.target.value;
        setStaff(val);
        setGenerated(false);
        setLopValidate(false);
        setLopInfo("");
        if (val !== "") {
            viewstructure(val).then((res) => {
                if (res.status === true && res.data.details !== null) {
                    const d = res.data.details;
                    setBasicRate(d.basic);
                    setBasicMonthly(d.basic);
                    setHraRate(d.hra);
                    setHraMonthly(d.hra);
                    setBonusRate(d.bonus);
                    setBonusMonthly(d.bonus);
                    setPf(d.pf);
                    setEsi(d.esi);
                    setPt(d.pt);
                }
            });
        }
    }

    // Auto LOP : derive paid days from clock in/out and prorate monthly earnings.
    function fetchLop() {
        setLopInfo("");
        if (staff === "" || month === "" || year === "") {
            setLopValidate(true);
            return;
        }
        setLopValidate(false);
        setLopfetching(true);
        const temp = new FormData();
        temp.append("staff_id", staff);
        temp.append("month", month);
        temp.append("year", year);
        payslipattendance(temp).then((res) => {
            setLopfetching(false);
            if (res && res.status === true) {
                const total = parseFloat(res.data.total_days) || 0;
                const present = parseFloat(res.data.present_days) || 0;
                const lop = Math.max(total - present, 0);
                setTotaldays(total);
                setPaydays(present);
                // Prorate monthly earnings from the full rate based on paid days.
                if (total > 0) {
                    const factor = present / total;
                    if (basicRate !== "") setBasicMonthly((n(basicRate) * factor).toFixed(2));
                    if (hraRate !== "") setHraMonthly((n(hraRate) * factor).toFixed(2));
                    if (bonusRate !== "") setBonusMonthly((n(bonusRate) * factor).toFixed(2));
                }
                setGenerated(false);
                setLopInfo(`Attendance: ${present} of ${total} days present, LOP ${lop} day(s)`);
            }
        });
    }

    // LOP Days is always Total Days - Pay Days (unpaid days).
    const lopdays = Math.max(n(totaldays) - n(paydays), 0);

    // Auto-computed figures (Total = Monthly + Arrear per component)
    const basicTotal = n(basicMonthly) + n(basicArrear);
    const hraTotal = n(hraMonthly) + n(hraArrear);
    const bonusTotal = n(bonusMonthly) + n(bonusArrear);

    const totalRate = n(basicRate) + n(hraRate) + n(bonusRate);
    const totalMonthly = n(basicMonthly) + n(hraMonthly) + n(bonusMonthly);
    const totalArrear = n(basicArrear) + n(hraArrear) + n(bonusArrear);
    const gross = basicTotal + hraTotal + bonusTotal;

    const totalded = n(pf) + n(esi) + n(pt);
    const netsalary = gross - totalded;
    const networds = numberToWordsINR(netsalary);

    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);

        liststaff(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setSList(res.data.details);
            }
        });

        if (path === "payslipdetail") {
            viewpayslip(id).then((res) => {
                if (res.status === true) {
                    const d = res.data.details;
                    if (d !== null) {
                        setStaff(d.staff_id);
                        setMonth(d.month);
                        setYear(d.year);
                        setPayDate(d.pay_date);
                        setPaydays(d.pay_days);
                        setAttarrear(d.attendance_arrear_days);
                        setIncarrear(d.increment_arrear_days);
                        setTotaldays(d.total_days);
                        setBasicRate(d.basic_rate);
                        setBasicMonthly(d.basic_monthly);
                        setBasicArrear(d.basic_arrear);
                        setHraRate(d.hra_rate);
                        setHraMonthly(d.hra_monthly);
                        setHraArrear(d.hra_arrear);
                        setBonusRate(d.bonus_rate);
                        setBonusMonthly(d.bonus_monthly);
                        setBonusArrear(d.bonus_arrear);
                        setPf(d.pf);
                        setEsi(d.esi);
                        setPt(d.pt);
                        setRemarks(d.remarks);
                        setGenerated(true);
                    }
                }
            })
        } else {
            setPayDate(moment(new Date()).format("YYYY-MM-DD"));
            setStaff("");
            setMonth("");
            setYear("");
            setPaydays("");
            setAttarrear("");
            setIncarrear("");
            setTotaldays("");
            setBasicRate("");
            setBasicMonthly("");
            setBasicArrear("");
            setHraRate("");
            setHraMonthly("");
            setHraArrear("");
            setBonusRate("");
            setBonusMonthly("");
            setBonusArrear("");
            setPf("");
            setEsi("");
            setPt("");
            setRemarks("");
            setGenerated(false);
        }
    }, [location.pathname]);

    const [successmsg, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    // Step 1 : validate + auto-generate the payslip breakdown preview
    function handleGenerate(e) {
        e.preventDefault();
        setSuccess(true);
        if (staff !== "" && month !== "" && year !== "" && paydate !== "" && basicMonthly !== "") {
            setGenerated(true);
        }
    }

    // Step 2 : persist the generated payslip
    function handleSave(e) {
        e.preventDefault();
        setSaveErr("");
        setLoading(true);

        const temp = new FormData();
        temp.append("staff_id", staff);
        temp.append("month", month);
        temp.append("year", year);
        temp.append("pay_date", paydate);
        temp.append("pay_days", n(paydays));
        temp.append("attendance_arrear_days", n(attarrear));
        temp.append("increment_arrear_days", n(incarrear));
        temp.append("total_days", n(totaldays));
        temp.append("lop_days", lopdays);

        temp.append("basic_rate", n(basicRate));
        temp.append("basic_monthly", n(basicMonthly));
        temp.append("basic_arrear", n(basicArrear));
        temp.append("basic_total", basicTotal);
        temp.append("hra_rate", n(hraRate));
        temp.append("hra_monthly", n(hraMonthly));
        temp.append("hra_arrear", n(hraArrear));
        temp.append("hra_total", hraTotal);
        temp.append("bonus_rate", n(bonusRate));
        temp.append("bonus_monthly", n(bonusMonthly));
        temp.append("bonus_arrear", n(bonusArrear));
        temp.append("bonus_total", bonusTotal);

        temp.append("total_earnings_rate", totalRate);
        temp.append("total_earnings_monthly", totalMonthly);
        temp.append("total_earnings_arrear", totalArrear);
        temp.append("gross_salary", gross);

        temp.append("pf", n(pf));
        temp.append("esi", n(esi));
        temp.append("pt", n(pt));
        temp.append("total_deduction", totalded);

        temp.append("net_salary", netsalary);
        temp.append("net_in_words", networds);
        temp.append("remarks", remarks);
        if (urllink !== "addpayslip") {
            temp.append("id", id);
        }
        createpayslip(temp).then((res) => {
            if (res.status === true) {
                setLoading(false);
                navigate("/payslip/allpayslip");
            } else {
                setLoading(false);
                setSaveErr(res.message || "Unable to save payslip");
            }
        })
    }

    const selectedStaff = slist.find((item) => String(item.id) === String(staff));
    const title = urllink === "addpayslip" ? "Add Payslip" : "Payslip Detail";

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">{title}</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Payslip</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {title}
                    </li>
                </ol>
            </div>

            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="content-body">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h2 className="main-content-title tx-24 mg-b-5">{title}</h2>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Staff<span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select form-control wide"
                                                    value={staff}
                                                    onChange={handleStaffChange}
                                                >
                                                    <option value="" disabled>Select Staff</option>
                                                    {slist.map((item) => (
                                                        <option key={item.id} value={item.id}>
                                                            {item.staff_name} ({item.staff_code})
                                                        </option>
                                                    ))}
                                                </select>
                                                {(successmsg || lopValidate) && staff === "" && (
                                                    <span className="text-danger">Please Select Staff</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Month<span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select form-control wide"
                                                    value={month}
                                                    onChange={anyChange(setMonth)}
                                                >
                                                    <option value="" disabled>Select Month</option>
                                                    {months.map((item) => (
                                                        <option key={item} value={item}>{item}</option>
                                                    ))}
                                                </select>
                                                {(successmsg || lopValidate) && month === "" && (
                                                    <span className="text-danger">Please Select Month</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Year<span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Year"
                                                    maxLength={4}
                                                    value={year}
                                                    onChange={numChange(setYear)}
                                                />
                                                {(successmsg || lopValidate) && year === "" && (
                                                    <span className="text-danger">Please Enter Year</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Pay Date<span className="text-danger"> *</span>
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        value={paydate}
                                                        onChange={anyChange(setPayDate)}
                                                        onKeyPress={(event) => event.preventDefault()}
                                                        onKeyDown={(event) => event.preventDefault()}
                                                    />
                                                </div>
                                                {successmsg && paydate === "" && (
                                                    <span className="text-danger">Please Enter Pay Date</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-xl-12">
                                            <div className="mb-2">
                                                <a
                                                    className={`btn btn-info btn-sm ${lopfetching ? "disabled" : ""}`}
                                                    onClick={() => { if (!lopfetching) fetchLop(); }}
                                                >
                                                    <i className="fa fa-clock-o me-1"></i>
                                                    {lopfetching ? "Fetching..." : "Auto LOP from Attendance"}
                                                </a>
                                                <small className="text-muted ms-2">
                                                    Reads clock in/out for the selected month and prorates monthly earnings.
                                                </small>
                                                {lopInfo !== "" && (
                                                    <div className="text-success mt-1">{lopInfo}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">Total Days</label>
                                                <input type="text" className="form-control" placeholder="Total Days"
                                                    value={totaldays} onChange={numChange(setTotaldays)} />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">Pay Days</label>
                                                <input type="text" className="form-control" placeholder="Enter Pay Days"
                                                    value={paydays} onChange={numChange(setPaydays)} />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">LOP Days</label>
                                                <input type="text" className="form-control" placeholder="LOP Days"
                                                    value={lopdays} readOnly />
                                                <small className="text-muted">Total Days − Pay Days</small>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">Attendance Arrear Days</label>
                                                <input type="text" className="form-control" placeholder="Attendance Arrear Days"
                                                    value={attarrear} onChange={numChange(setAttarrear)} />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">Increment Arrear Days</label>
                                                <input type="text" className="form-control" placeholder="Increment Arrear Days"
                                                    value={incarrear} onChange={numChange(setIncarrear)} />
                                            </div>
                                        </div>
                                    </div>

                                    <h4 className="mt-2 mb-3">Earnings (INR)</h4>
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Components</th>
                                                    <th>Rate</th>
                                                    <th>Monthly<span className="text-danger"> *</span></th>
                                                    <th>Arrear</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Basic</td>
                                                    <td><input type="text" className="form-control" value={basicRate} onChange={numChange(setBasicRate)} /></td>
                                                    <td><input type="text" className="form-control" value={basicMonthly} onChange={numChange(setBasicMonthly)} /></td>
                                                    <td><input type="text" className="form-control" value={basicArrear} onChange={numChange(setBasicArrear)} /></td>
                                                    <td>{basicTotal.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td>HRA</td>
                                                    <td><input type="text" className="form-control" value={hraRate} onChange={numChange(setHraRate)} /></td>
                                                    <td><input type="text" className="form-control" value={hraMonthly} onChange={numChange(setHraMonthly)} /></td>
                                                    <td><input type="text" className="form-control" value={hraArrear} onChange={numChange(setHraArrear)} /></td>
                                                    <td>{hraTotal.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Advance towards statutory Bonus</td>
                                                    <td><input type="text" className="form-control" value={bonusRate} onChange={numChange(setBonusRate)} /></td>
                                                    <td><input type="text" className="form-control" value={bonusMonthly} onChange={numChange(setBonusMonthly)} /></td>
                                                    <td><input type="text" className="form-control" value={bonusArrear} onChange={numChange(setBonusArrear)} /></td>
                                                    <td>{bonusTotal.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Total Earnings</b></td>
                                                    <td><b>{totalRate.toFixed(2)}</b></td>
                                                    <td><b>{totalMonthly.toFixed(2)}</b></td>
                                                    <td><b>{totalArrear.toFixed(2)}</b></td>
                                                    <td><b>{gross.toFixed(2)}</b></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {successmsg && basicMonthly === "" && (
                                        <span className="text-danger">Please Enter Basic (Monthly)</span>
                                    )}

                                    <h4 className="mt-2 mb-3">Deductions (INR)</h4>
                                    <div className="row">
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">PF</label>
                                                <input type="text" className="form-control" placeholder="Enter PF"
                                                    value={pf} onChange={numChange(setPf)} />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">ESI</label>
                                                <input type="text" className="form-control" placeholder="Enter ESI"
                                                    value={esi} onChange={numChange(setEsi)} />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">PT</label>
                                                <input type="text" className="form-control" placeholder="Enter PT"
                                                    value={pt} onChange={numChange(setPt)} />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">Total Deductions</label>
                                                <input type="text" className="form-control" value={totalded.toFixed(2)} readOnly />
                                            </div>
                                        </div>
                                        <div className="col-xl-12">
                                            <div className="mb-3">
                                                <label className="form-label">Remarks</label>
                                                <input type="text" className="form-control" placeholder="Enter Remarks"
                                                    value={remarks} onChange={anyChange(setRemarks)} />
                                            </div>
                                        </div>
                                    </div>

                                    {!generated && (
                                        <div className="card-footer">
                                            <div className="text-right">
                                                <a className="btn btn-primary me-2" onClick={(e) => handleGenerate(e)}>Generate</a>
                                                <a className="btn btn-secondary" onClick={() => navigate("/payslip/allpayslip")}> Back</a>
                                            </div>
                                        </div>
                                    )}

                                    {generated && (
                                        <>
                                            <h4 className="mt-2 mb-3">Payslip Summary</h4>
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    <tbody>
                                                        <tr>
                                                            <td>Staff</td>
                                                            <td>{selectedStaff ? `${selectedStaff.staff_name} (${selectedStaff.staff_code})` : ""}</td>
                                                            <td>Pay Period</td>
                                                            <td>{month} {year}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Gross Salary</b></td>
                                                            <td><b>{gross.toFixed(2)}</b></td>
                                                            <td><b>Total Deductions</b></td>
                                                            <td><b>{totalded.toFixed(2)}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Net Pay</b></td>
                                                            <td><b>{netsalary.toFixed(2)}</b></td>
                                                            <td><b>In Words</b></td>
                                                            <td><b>{networds}</b></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="card-footer">
                                                <div className="text-right">
                                                    <a className="btn btn-success me-2" onClick={(e) => handleSave(e)}>
                                                        {urllink === "addpayslip" ? "Save" : "Update"}
                                                    </a>
                                                    <a className="btn btn-warning me-2" onClick={() => setGenerated(false)}>Edit</a>
                                                    <a className="btn btn-secondary" onClick={() => navigate("/payslip/allpayslip")}> Back</a>
                                                    {saveErr !== "" && (
                                                        <div className="text-danger mt-2">{saveErr}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
